import { ReactElement } from "react"

import CreateDeviceForm from "../../../../components/devices/ttr/createDeviceForm"
import NewDeviceVersionProvider from "../../../../components/devices/ttr/providers/newDeviceVersionProvider"

/**
 * Webpage for allowing users to create a new device version.
 * Similar to `<RegisterDevice />` but uses a different context
 */
const NewDeviceVersion = (): ReactElement => (
    <NewDeviceVersionProvider>
        <CreateDeviceForm />
    </NewDeviceVersionProvider>
)

export default NewDeviceVersion
